import { useState, useEffect, useCallback } from "react";
import { apiService } from "../api/services/apiService";
import type { DeveloperGuide } from "../types";

export const useDeveloperGuides = () => {
  const [developerGuides, setDeveloperGuides] = useState<DeveloperGuide[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDeveloperGuides = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getDeveloperGuides();
      setDeveloperGuides(data);
    } catch (err: unknown) {
      console.error(err);
      setError(err instanceof Error ? err.message : "Failed to fetch developer guides");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDeveloperGuides();
  }, [fetchDeveloperGuides]);

  return { developerGuides, loading, error, refresh: fetchDeveloperGuides };
};
